// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { TombolaProvider } from "./contexts/TombolaContext";
import { OrgProvider } from "./contexts/OrgContext";
import { ProfilProvider } from "./contexts/ProfilContext";
import Connexion from "./pages/Connexion";
import SelectionOrg from "./pages/SelectionOrg";
import Inscription from "./pages/Inscription";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";
import Confirmation from "./pages/Confirmation";
import LotsPublics from "./pages/LotsPublics";
import Rejoindre from "./pages/Rejoindre";
import PaiementSucces from "./pages/PaiementSucces";
import ChoixAssociation from "./pages/ChoixAssociation";

// ─── Route protégée ───────────────────────────────────────────────────────────
function PrivateRoute({ children }) {
  const { currentUser, loading, needsOrgSelection, besoinAsso } = useAuth();
  if (loading) return <div style={loadingStyle}>⏳ Chargement…</div>;
  if (!currentUser) return <Navigate to="/connexion" replace />;
  if (besoinAsso) return <ChoixAssociation />;
  if (needsOrgSelection) return <SelectionOrg />;
  return children;
}

// ─── Route publique (redirige si connecté) ────────────────────────────────────
function PublicRoute({ children }) {
  const { currentUser, loading } = useAuth();
  if (loading) return <div style={loadingStyle}>⏳ Chargement…</div>;
  return currentUser ? <Navigate to="/" replace /> : children;
}

const loadingStyle = {
  minHeight: "100vh", display: "flex", alignItems: "center",
  justifyContent: "center", fontSize: "1.1rem", color: "#667eea",
  fontFamily: "system-ui, sans-serif",
};

// ─── Routes app ───────────────────────────────────────────────────────────────
function AppRoutes() {
  return (
    <Routes>
      {/* Pages publiques — sans connexion */}
      <Route path="/confirmation/:venteId/:orgId/:tombolaId" element={<Confirmation />} />
      <Route path="/lots/:orgId/:tombolaId" element={<LotsPublics />} />
      <Route path="/rejoindre/:orgId/:tombolaId/:invitId" element={<Rejoindre />} />
      <Route path="/paiement-succes" element={<PaiementSucces />} />

      {/* Pages auth */}
      <Route path="/connexion" element={<PublicRoute><Connexion /></PublicRoute>} />
      <Route path="/inscription" element={<PublicRoute><Inscription /></PublicRoute>} />

      {/* App principale — protégée */}
      <Route path="/" element={
        <PrivateRoute>
          <OrgProvider>
            <TombolaProvider>
              <ProfilProvider>
                <Dashboard />
              </ProfilProvider>
            </TombolaProvider>
          </OrgProvider>
        </PrivateRoute>
      } />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
